import React, { useEffect, useState } from "react";
import { Button, Modal, Tooltip } from "@material-ui/core";

// icons
import Delete from "@material-ui/icons/Delete";
import { MdClose } from "react-icons/md";
import { AiOutlineLoading3Quarters } from "react-icons/ai";

import "../styles/modalStyles.css";
import ShowcaseService from "../../services/ShowcaseService";

function SearchDropdown({ query, results, clickFunc, onClose }) {
  return (
    <div className="showcase-book-search-results">
      {results.length ? (
        results.map((r, i) => {
          return (
            <div key={i} className="showcase-search-results-item" onClick={() => clickFunc(r)}>
              <span className="showcase-book-search-title">{r.title}</span>
              <span className="showcase-book-search-domain">{r.domainName}</span>
            </div>
          );
        })
      ) : (
        <div className="showcase-search-results-item" id="no-results">
          <span>{`No book titles including "${query}"`}</span>
        </div>
      )}
    </div>
  );
}

function ManageShowcaseModal({ open, onClose, showcase, allBooks }) {
  const [searchQuery, setSearchQuery] = useState("");
  const [searchResults, setSearchResults] = useState(null);
  const [bookList, setBookList] = useState([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (showcase) {
      setBookList(showcase.books);
    }
  }, [showcase]);

  const addBook = (book) => {
    let temp = bookList.slice();
    temp.unshift(book);
    setBookList(temp);
    setSearchQuery("");
  };

  const save = () => {
    let temp = bookList.map((book) => {
      return book.id;
    });
    console.log("temp:", temp);
    setLoading(true);
    ShowcaseService.updateBooks(showcase.id, { books: temp })
      .then(() => {
        setLoading(false);
        onClose();
      })
      .catch((e) => {
        setLoading(false);
        console.log("Error saving books to showcase:", e);
      });
  };

  const cancel = () => {
    setSearchQuery("");
    setBookList(showcase.books.slice());
    setSearchResults(null);
    onClose();
  };

  const removeBook = (id) => {
    let ids = bookList.map((b) => {
      return b.id;
    });
    let index = ids.indexOf(id);
    let temp = bookList.slice();
    temp.splice(index, 1);
    setBookList(temp);
  };

  const handleSearch = (e) => {
    setSearchQuery(e.target.value);
  };

  const clearAllBooks = () => {
    setBookList([]);
  };

  useEffect(() => {
    let currentBookIds = [];
    if (showcase && showcase.books)
      currentBookIds = showcase.books.map((book) => {
        return book.id;
      });
    if (searchQuery.length) {
      let temp = allBooks.filter((book) => {
        return !currentBookIds.includes(book.id) && book.title.toLowerCase().includes(searchQuery.toLowerCase());
      });
      setSearchResults(temp);
    } else setSearchResults(null);
  }, [searchQuery]);

  return (
    <Modal open={open} onClose={onClose} className="showcase-modal">
      <div className="showcase-modal-content">
        <h2>Manage books in showcase</h2>
        <div className="showcase-book-search">
          <h5>Search for books</h5>
          <div className="showcase-book-search-and-dropdown">
            <div className="showcase-book-search-textbox">
              <input type="text" disabled={loading} value={searchQuery} onChange={handleSearch} />
              <MdClose className="clear-search" onClick={() => setSearchQuery("")} />
            </div>
            {searchResults && <SearchDropdown query={searchQuery} results={searchResults} clickFunc={addBook} />}
          </div>
        </div>
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            position: "relative",
            width: "75%",
            marginBottom: "0.5rem",
          }}
        >
          <h5 style={{ margin: "2rem 0 0 0" }}>Current books in showcase</h5>
          <div className={`clear-all-books-in-showcase ${loading ? "disabled" : ""}`} onClick={clearAllBooks}>
            Clear all
          </div>
        </div>
        <div className="books-in-showcase-overflow-container">
          <div className="books-in-showcase">
            <ul className="showcase-modal-books-list">
              {bookList && bookList.length
                ? bookList.map((book, i) => {
                    return (
                      <li key={i}>
                        <div style={{ position: "relative" }}>
                          <span id="title">{book.title}</span>
                          <div style={{ display: "flex", alignItems: "center" }}>
                            <span id="domain">{book.domainName}</span>
                            <Tooltip title="Remove book">
                              <div
                                className={`remove-book-button ${loading ? "disabled" : ""}`}
                                onClick={() => removeBook(book.id)}
                              >
                                <Delete color="error" />
                              </div>
                            </Tooltip>
                          </div>
                        </div>
                      </li>
                    );
                  })
                : null}
            </ul>
            {(!bookList || bookList.length === 0) && (
              <div
                style={{
                  width: "100%",
                  padding: "0.5rem",
                  textAlign: "center",
                }}
              >
                No books!
              </div>
            )}
          </div>
        </div>
        <div className="showcase-modal-buttons">
          <Button style={{ marginRight: "1rem" }} color="secondary" disabled={loading} onClick={cancel}>
            Cancel
          </Button>
          <Button color="primary" disabled={loading} onClick={save}>
            Save
          </Button>
          {loading && (
            <div className="showcase-book-loading-spinner">
              <AiOutlineLoading3Quarters />
            </div>
          )}
        </div>
      </div>
    </Modal>
  );
}

export default ManageShowcaseModal;
